var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaxSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 32,
    viewBox: "0 0 116 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9219 0.0207708C30.3539 0.0148879 26.9213 1.38643 24.3398 3.84944L23.949 4.22042L23.5592 3.84944C19.5948 0.089417 13.8 -1.0094 8.7344 1.03835L7.95469 1.34986C7.95469 0.628335 7.36978 0.0434257 6.64826 0.0434257H0V31.9821H7.95469V14.0857C7.95469 10.796 10.5581 8.04437 13.8468 7.97829C15.4597 7.94867 17.0169 8.56826 18.1685 9.69789C19.3202 10.8275 19.9697 12.3724 19.9712 13.9856V31.984H27.9268V14.0847C27.9268 10.795 30.5293 8.04343 33.8181 7.97829C35.4308 7.94892 36.9877 8.56863 38.1391 9.69823C39.2906 10.8278 39.94 12.3726 39.9415 13.9856V31.984H47.8971V13.9856C47.8896 6.29428 41.6198 0.0292664 33.9219 0.0207708Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.179 3.04049C73.179 1.37223 74.5314 0.0198364 76.1996 0.0198364H80.8967V31.8537H76.3554C74.6046 31.8532 73.1856 30.4337 73.1856 28.683C70.9796 30.7493 67.7446 31.9764 64.1661 31.9764C59.789 31.9764 55.8688 30.3594 53.1219 27.4237C50.4269 24.5447 48.943 20.4885 48.943 16.0019C48.943 6.7455 55.4346 0.027388 64.3776 0.027388C67.8513 0.027388 71.0079 1.15069 73.179 3.04049ZM65.0751 24.3738C67.2991 24.3738 69.3078 23.5375 70.7313 22.0272C72.169 20.4989 72.9609 18.3401 72.9609 15.9481C72.9609 10.9876 69.7185 7.52237 65.0751 7.52237C60.5074 7.52237 57.1894 11.066 57.1894 15.9481C57.1894 20.8302 60.5055 24.3738 65.0751 24.3738Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.711 0H103.005C102.507 0.000735736 102.044 0.256502 101.778 0.677758L92.1392 15.9264L101.776 31.1769C102.042 31.5981 102.505 31.8539 103.003 31.8546H110.708L100.643 15.9273L110.711 0Z",
    fill: "url(#paint0_linear_0_1065)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7775 0H82.071L92.1392 15.9311L82.071 31.8584H89.7756C90.2737 31.8577 90.7368 31.6019 91.0027 31.1806L100.642 15.9311L91.0074 0.681534C90.7415 0.258385 90.2772 0.00111776 89.7775 0Z",
    fill: "url(#paint1_linear_0_1065)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.479 29.9233H112.826V31.9717H112.466V29.9233H111.813V29.6005H113.479V29.9233Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.982 31.9717H115.622V30.3859L115.075 31.5422H114.809L114.249 30.3859V31.9717H113.889V29.5995H114.249L114.942 31.0749L115.622 29.5995H115.982V31.9717Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1065",
    x1: 108.515,
    y1: -18.6391,
    x2: 72.9817,
    y2: -8.50497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E71E3D",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C81A46",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8A1057",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#590965",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#36046E",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#220174",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0076",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1065",
    x1: 100.352,
    y1: -23.8245,
    x2: 66.8521,
    y2: -16.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E71E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C61946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#991353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#720D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#530866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3A056D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#290272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#1E0075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B0076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxSvg);
export default __webpack_public_path__ + "static/media/MaxSvg.d29a3b4655bd977d0b480cae46ec96c2.svg";
export { ForwardRef as ReactComponent };